module.exports = __webpack_public_path__ + "S33.png";